/**
 * page : 설계 견적 문의 detail
 */

import { useEffect, useState, useConfirm } from 'react';
import * as zy from '../common/zeroyear-1.0.0';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from "sweetalert2";
let sessionStorage = window.sessionStorage;

const dataObject = {ESTMTE_SEQ: '', ESTMTE_NO: '', ESTMTE_DV: '20', ESTMTE_REG_NM: '', ESTMTE_PW: '', ESTMTE_TITLE: '', ESTMTE_CONTENT: ''};
export default function DesignEstimateDetail () {
    const [admin, setAdmin] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const [showReplyModalModi, setShowReplyModalModi] = useState(false); // 답변 모달창
    const [showReplyModal, setShowReplyModal] = useState(false); // 답변 모달창
    const [showReplyReModal, setShowReplyReModal] = useState(false); // 답변 모달창
    const [showAlert, setShowAlert] = useState(false); // 패스워드 불일치 alert
    const [showAlertSave, setShowAlertSave] = useState(false); // 수정완료 alert
    const [showAlertReply, setShowAlertReply] = useState(false); // 수정완료 alert
    const [loading, setLoading] = useState(true);
    const [estmte, setEstmte] = useState({});
    const [data, setData] = useState(dataObject);
    const [mdata, setMdata] = useState({});
    const [replyReData, setReplyRe] = useState({});
    const [replyList, setReply] = useState([]);
    const [replyReList, setReplyReList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [validated, setValidated] = useState(false);
    /**
     * 삭제
     */
    const deleteDesign = () => {
        Swal.fire({
            icon: "warning",
            text: "삭제 하시겠습니까?",
            showCancelButton: true,
            confirmButtonText: '삭제',
            cancelButtonText: '취소',
            confirmButtonColor: '#cc1616',
        }).then((res) => {
            if (res.isConfirmed) {
                zy.destroy('deleteEstmte', [id], (item) => {
                    navigate('/DesignEstimate');
                });
             }
            else{ }
        });
    };
    const selectAll = () => {
        zy.select('selectEstmte', [id],(item) => {
            zy.select('selectReply', [id], (itemB) => {
                zy.select('selectReplyRe', [id], (itemC) => {
                    setEstmte(item[0]);
                    setData({...data, ESTMTE_SEQ: id});
                    setReply(itemB);
                    setReplyReList(itemC);
                    setLoading(false);
                });
            });
        });
    };
    useEffect(()=>{
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    },[]);
    /**
     * close modal 수정하기
     */
    const closeModal = () => {
        setValidated(false);
        setShowModal(false);
    };
    /**
     * open modal 수정하기
     */
    const openModal = () => {
        setValidated(false);
        setShowModal(true);
        setData({...data, ESTMTE_TITLE: estmte.ESTMTE_TITLE, ESTMTE_REG_NM: estmte.ESTMTE_REG_NM, ESTMTE_CONTENT: estmte.ESTMTE_CONTENT});
    };
    /**
     * close modal 답변하기
     */
    const closeReplyModal = () => {
        setShowReplyModal(false);
    };
    /**
     * open modal 답변하기
     */
    const openReplyModal = () => {
        setShowReplyModal(true);
        setData({...data, ESTMTE_REPLY: estmte.ESTMTE_REPLY});
    };
    /**
     * close modal 답변하기
     */
    const closeReplyModalModi = () => {
        setShowReplyModalModi(false);
    };
    /**
     * open modal 답변하기
     */
    const openReplyModalModi = () => {
        setShowReplyModalModi(true);
    };
    /**
     * close modal 답변하기
     */
    const closeReplyReModal = () => {
        setReplyRe({});
        setShowReplyReModal(false);
    };
    /**
     * open modal 답변하기
     */
    const openReplyReModal = () => {
        setShowReplyReModal(true);
    };
    const closeAlert = () => { setShowAlert(false); } // 패스워드 불일치 alert 닫기
    const closeAlertSave = () => { setShowAlertSave(false); } // 수정완료 alert 닫기
    const closeAlertReply = () => { setShowAlertReply(false); } // 답변완료 alert 닫기
    /**
     * 목록 이동
     */
    const locateList = () => {
        navigate('/DesignEstimate');
    }

    /**
     * 작성자 change event
     */
    const changeRegNm = (event) => {
        setData({...data, ESTMTE_REG_NM: event?.target.value});
    }
    /**
     * 비밀번호 change event
     */
    const changePw = (event) => {
        setData({...data, ESTMTE_PW: event?.target.value});
    }
    /**
     * 제목 change event
     */
    const changeTitle = (event) => {
        setData({...data, ESTMTE_TITLE: event?.target.value});
    }
    /**
     * 내용 change event
     */
    const changeContent = (event) => {
        setData({...data, ESTMTE_CONTENT: event?.target.value});
    }
    /**
     * 답변 change event
     */
    const changeReply = (event) => {
        setData({...data, ESTMTE_REPLY: event?.target.value});
    }
    const changeReplyRe = (event) => {
        setReplyRe({...replyReData, REPLY_CONTENT: event?.target.value});
    }
    const changeReplyReModi = (event) => {
        setMdata({...mdata, REPLY_CONTENT: event?.target.value});
    }
    
    /**
     * 수정 event handler
     */
    const saveDesign = (event) => {
        const form = event.currentTarget;
        if (!admin) {
            if (data.ESTMTE_PW !== estmte.ESTMTE_PW) {
                Swal.fire({
                    icon: "error",
                    text: "비밀번호가 일치하지 않습니다.",
                }).then((res) => {
                    if (res.isConfirmed) { }
                    else{ }
                });
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        }
        if (form.checkValidity() === false) {
            // validate
            event.preventDefault();
            event.stopPropagation();
        } else {
            // 저장
            event.preventDefault();
            event.stopPropagation();
            zy.modify('updateEstmte', [
                data.ESTMTE_TITLE, data.ESTMTE_REG_NM, data.ESTMTE_CONTENT, data.ESTMTE_SEQ, data.ESTMTE_DV
            ], (item) => {
                if (item.affectedRows > 0) {
                    // 저장 완료
                    closeModal();
                    selectAll();
                }
            });
        }
        setValidated(true);
    };
    /**
     * 답변 event handler
     */
    const saveReply = (event) => {
        const form = event.currentTarget;
        let regId = admin ? 'ADMIN' : 'USER';
        // 저장
        event.preventDefault();
        event.stopPropagation();
        zy.create('insertReply', [
            data.ESTMTE_SEQ, data.ESTMTE_REPLY, regId
        ], (item) => {
            if (item.affectedRows > 0) {
                // 답변 완료
                // setShowAlertReply(true);
                closeReplyModal();
                selectAll();
            }
        });
    };
    /**
     * 답변 event handler
     */
    const saveReplyRe = (event) => {
        const form = event.currentTarget;
        let regId = admin ? 'ADMIN' : 'USER';
        // 저장
        event.preventDefault();
        event.stopPropagation();
        zy.create('insertReplyRe', [
            id, replyReData.REPLY_SEQ, replyReData.REPLY_CONTENT, regId
        ], (item) => {
            if (item.affectedRows > 0) {
                // 답변 완료
                closeReplyReModal();
                selectAll();
            }
        });
    }
    // 답답변 수정
    const saveReplyReModi = (event) => {
        if (mdata.flag === 'RE') {
            // 답답글
            zy.modify('updateEstmteReplyRe',[
                mdata.REPLY_CONTENT, mdata.REPLY_RE_SEQ
            ], (item) => {
                closeReplyModalModi();
                selectAll();
            });
        } else {
            // 답글
            zy.modify('updateEstmteReply',[
                mdata.REPLY_CONTENT, mdata.REPLY_SEQ
            ], (item) => {
                closeReplyModalModi();
                selectAll();
            });
        }
    }
    const replyReplyClick = (event) => {
        let flag = event.target.dataset.flag;
        let seq = event.target.dataset.seq;
        let isRe = event.target.dataset.reply === 'RE' ? true : false;

        if (flag === 'R') {
            // 답글
            setReplyRe({ REPLY_SEQ: seq, REPLY_CONTENT: '' })
            openReplyReModal();
        } else if (flag === 'M') {
            // 수정
            if (isRe) {
                // 답답글 수정
                let reply = replyReList.find((r) => r.REPLY_RE_SEQ == seq);
                if (reply) {
                    setMdata({ REPLY_RE_SEQ: seq, REPLY_CONTENT: reply.REPLY_CONTENT, flag: 'RE' });
                    openReplyModalModi();
                }
            } else {
                // 답글 수정
                let reply = replyList.find((r) => r.REPLY_SEQ == seq);
                if (reply) {
                    setMdata({ REPLY_SEQ: seq, REPLY_CONTENT: reply.REPLY_CONTENT, flag: '' });
                    openReplyModalModi();
                }
            }
        } else if (flag === 'D') {
            // 삭제
            Swal.fire({
                icon: "warning",
                text: "삭제 하시겠습니까?",
                showCancelButton: true,
                confirmButtonText: '삭제',
                cancelButtonText: '취소',
                confirmButtonColor: '#cc1616',
            }).then((res) => {
                if (res.isConfirmed) {
                    if (isRe) {
                        // 답답글 삭제
                        zy.destroy('deleteNoticeReplyRe',[
                            seq
                        ], (item) => {
                            selectAll();
                        });
                    } else {
                        // 답글 삭제
                        zy.destroy('deleteNoticeReply',[
                            seq
                        ], (item) => {
                            selectAll();
                        });
                    }
                 }
                else{ }
            });
        }
    }
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">설계사업부</a></li>
                        <li>견적문의</li>
                    </ol>
                    <h2>견적문의</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="row gy-4">
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>글번호</Form.Label>
                                <Form.Control type="text" className="read-cont" value={estmte.ESTMTE_NO||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>작성자</Form.Label>
                                <Form.Control type="text" className="read-cont" value={estmte.ESTMTE_REG_NM||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>제목</Form.Label>
                                <Form.Control type="text" className="read-cont" value={estmte.ESTMTE_TITLE||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>작성일자</Form.Label>
                                <Form.Control type="text" className="read-cont" value={estmte.REG_DTM||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>내용</Form.Label>
                                <Form.Control as="textarea" className="read-cont" rows={5} value={estmte.ESTMTE_CONTENT||''} readOnly disabled/>
                            </Form.Group>
                        </Form>
                        <hr></hr>
                        {replyList.length === 0 ? (
                            <div style={{textAlign: 'center'}}>답변 대기중 입니다.</div>) :
                            replyList.map((reply, index) => {
                                let reList = replyReList.filter((r) => r.REPLY_SEQ === reply.REPLY_SEQ);
                                return (
                                    <div key={reply.REPLY_SEQ}>
                                    <Form>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>관리자 <span style={{fontSize: '12.5px', color: '#8a8a8a'}}>{reply.REG_DTM}  </span>
                                            {admin ? <span onClick={replyReplyClick} data-seq={reply.REPLY_SEQ} data-reply={'NO'} data-flag={'M'} style={{fontSize: '12.5px', color: '#4657c1', cursor: 'pointer'}}>수정  </span> : null}
                                            {admin ? <span onClick={replyReplyClick} data-seq={reply.REPLY_SEQ} data-reply={'NO'} data-flag={'D'} style={{fontSize: '12.5px', color: '#ff7f7f', cursor: 'pointer'}}>삭제  </span> : null}
                                            <span onClick={replyReplyClick} data-seq={reply.REPLY_SEQ} data-reply={'NO'} data-flag={'R'} style={{fontSize: '12.5px', color: '#8a8a8a', cursor: 'pointer'}}>답글쓰기</span>
                                        </Form.Label>
                                        <Form.Control as="textarea" className="read-cont" rows={3} value={reply.REPLY_CONTENT||''} readOnly disabled/>
                                        </Form.Group>
                                    </Form>
                                    {
                                        reList.map((rere, indexRe) => {
                                            return (
                                                <Form key={rere.REPLY_RE_SEQ} style={{marginLeft: '45px'}}>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                    <Form.Label>{rere.REG_ID === 'USER' ? '작성자' : '관리자'} <span style={{fontSize: '12.5px', color: '#8a8a8a'}}>{rere.REG_DTM}  </span>
                                                        {admin || rere.REG_ID === 'USER' ? <span onClick={replyReplyClick} data-seq={rere.REPLY_RE_SEQ} data-reply={'RE'} data-flag={'M'} style={{fontSize: '12.5px', color: '#4657c1', cursor: 'pointer'}}>수정  </span> : null}
                                                        {admin || rere.REG_ID === 'USER' ? <span onClick={replyReplyClick} data-seq={rere.REPLY_RE_SEQ} data-reply={'RE'} data-flag={'D'} style={{fontSize: '12.5px', color: '#ff7f7f', cursor: 'pointer'}}>삭제  </span> : null}
                                                        { reList.length == indexRe+1 ? <span onClick={replyReplyClick} data-seq={rere.REPLY_SEQ} data-reply={'RE'} data-flag={'R'} style={{fontSize: '12.5px', color: '#8a8a8a', cursor: 'pointer'}}>답글쓰기</span> : null }
                                                    </Form.Label>
                                                    <Form.Control as="textarea" className="read-cont" rows={3} value={rere.REPLY_CONTENT||''} readOnly disabled/>
                                                    </Form.Group>
                                                </Form>
                                            );
                                        })
                                    }
                                    </div>
                                )
                            })
                        }
                        <hr style={{marginTop: '35px'}}></hr>
                    </div>
                    <div style={{float: 'right'}}>
                        <button className="btn-cancel" onClick={locateList}>목록</button>
                        <button className="btn-normal" onClick={openModal}>수정</button>
                        { admin ? <button className="btn-normal" onClick={openReplyModal}>답변</button> : null }
                        <button className="btn-delete" onClick={deleteDesign}>삭제</button>
                    </div>
                </div>
            </section>

            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated} onSubmit={saveDesign}>
                    <Modal.Header closeButton>
                    <Modal.Title>문의글 수정</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_DV">
                            <Form.Label>분류</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                defaultValue={'설계'} disabled readOnly/>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_REG_NM">
                            <Form.Label>작성자</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changeRegNm}
                                value={data.ESTMTE_REG_NM||''}
                                required/>
                            <Form.Control.Feedback type="invalid">작성자를 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_PW">
                            <Form.Label>비밀번호</Form.Label>
                            <Form.Control
                                type="password"
                                onChange={changePw}
                                placeholder="비밀번호 입력 (8~12)"
                                maxLength={12}
                                disabled={admin ? true : false}
                                required
                            />
                            <Form.Control.Feedback type="invalid">비밀번호를 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_TITLE">
                            <Form.Label>제목</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={changeTitle}
                                placeholder=""
                                value={data.ESTMTE_TITLE||''}
                                required/>
                            <Form.Control.Feedback type="invalid">제목을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_CONTENT">
                            <Form.Label>내용</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeContent}
                                rows={6}
                                value={data.ESTMTE_CONTENT||''}
                                required/>
                            <Form.Control.Feedback type="invalid">내용을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Modal.Footer>
                            <button className="btn-cancel" type="button" onClick={closeModal}>닫기</button>
                            <button className="btn-normal" type="submit">수정</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
            {/* 답변 Modal */}
            <Modal 
                show={showReplyModal}
                onHide={closeReplyModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated} onSubmit={saveReply}>
                    <Modal.Header closeButton>
                    <Modal.Title>답변하기</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_CONTENT">
                            <Form.Label>답변</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeReply}
                                rows={6}
                                required/>
                        </Form.Group>
                        <Modal.Footer>
                            <button className="btn-cancel" type="button" onClick={closeReplyModal}>닫기</button>
                            <button className="btn-normal" type="submit">답변</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
            <Modal 
                show={showReplyReModal}
                onHide={closeReplyReModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated} onSubmit={saveReplyRe}>
                    <Modal.Header closeButton>
                    <Modal.Title>답변하기</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_CONTENT">
                            <Form.Label>답변</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeReplyRe}
                                rows={6}
                                required/>
                        </Form.Group>
                        <Modal.Footer>
                            <button className="btn-cancel" type="button" onClick={closeReplyReModal}>닫기</button>
                            <button className="btn-normal" type="submit">답변</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
            <Modal 
                show={showReplyModalModi}
                onHide={closeReplyModalModi}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated}>
                    <Modal.Header closeButton>
                    <Modal.Title>답변 수정</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_CONTENT">
                            <Form.Label>답변</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeReplyReModi}
                                defaultValue={mdata.REPLY_CONTENT}
                                rows={6}
                                required/>
                        </Form.Group>
                        <Modal.Footer>
                            <button className="btn-cancel" type="button" onClick={closeReplyModalModi}>닫기</button>
                            <button className="btn-normal" type="button" onClick={saveReplyReModi}>수정</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
            <Modal 
                show={showAlert}
                onHide={closeAlert}
                backdrop="static"
                keyboard={false}
                >
                <Modal.Header closeButton>
                <Modal.Title>조건 확인</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    비밀번호가 일치하지 않습니다.
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn-cancel" onClick={closeAlert}>닫기</button>
                </Modal.Footer>
            </Modal>
            <Modal 
                show={showAlertSave}
                onHide={closeAlertSave}
                backdrop="static"
                keyboard={false}
                >
                <Modal.Header closeButton>
                <Modal.Title>안내</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    수정 되었습니다.
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn-cancel" onClick={closeAlertSave}>닫기</button>
                </Modal.Footer>
            </Modal>
        </main>
        </>
    );
}